import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, Validators } from '@angular/forms';
import { DatabaseService } from 'src/app/_services/database.service';
import swal from 'sweetalert';
import * as moment from 'moment';
import { CustomEventsService } from 'src/app/_services/custom-events.service';
// import { type } from 'os';

@Component({
  selector: 'app-dr-add',
  templateUrl: './dr-add.component.html',
  // styleUrls: ['./dr-add.component.scss']
})
export class DrAddComponent implements OnInit {
  type:any = this.activatedroute.snapshot.params.type
  typeName:any = this.type == 3 ? 'Carpenter' : ''
  
  constructor(public events:CustomEventsService,public activatedroute:ActivatedRoute ,private _location: Location,public db:DatabaseService) { }
  
  ngOnInit() {
    this.getDrType()
    this.db.getStates();
    this.getBrands();
    this.getDealers();
    // this.getSalesUser();
    this.getUsers();
    if(this.activatedroute.snapshot.params.id){
      this.getDetail(this.activatedroute.snapshot.params.id)
    }    else{
      this.formsInit({});
    } 
  }
  salesUserDetail:any;

//   dataNotFound = false;
//   data :any;
//   reqSent = false;
//   todayDate :any
//   pageNo:any=1;
//   tempPageNo =1;
//   totalPages:any
//   start:any=0;
//   limit:any=50;
//   totalLength:any;
//   filter:any={};

// getSalesUser(){
//   this.dataNotFound = false;
//   this.reqSent = false;
//   let reqData = {
//     limit : this.limit,
//     start : this.start,
//     filter : this.filter
//   }
//   this.db.presentLoader();
//   this.db.postReq(reqData,'master/sales_user').subscribe(resp=>{
//     this.reqSent = true;
//     if(resp['status'] == 'success'){
//       this.data = resp['result'].data;
//       console.log(this.data);
//       if(!this.data.length) this.dataNotFound = true;
//       this.totalLength = resp['result'].totalCount;
//       this.totalPages = Math.ceil(this.totalLength / this.limit);
//     }else{
//       if(resp['message']=='Invalid token'){
//         this.db.sessionExpire();
//         return;
//       }
//       this.db.presentAlert(resp['status'],resp['message'])
//     }
//   },err=>{
    
//   })
// }



  getDetail(id){
    this.db.presentLoader();
    
    this.db.postReq({'customer_id':id},'dis_network/detail').subscribe(resp=>{
      this.db.dismissLoader();
      if(resp['status'] == 'success'){
        this.salesUserDetail = resp['data']['salesUserDetail'];
        this.formsInit(resp['data']);
      }else{
        if(resp['message']=='Invalid token'){
          this.db.sessionExpire();
          return;
        }
        this.db.presentAlert(resp['status'],resp['message'])
      }
    },err=>{
      this.db.errHandler(err);
    })
    
  }
  getDrType(){
    this.db.postReq({},'dis_network/type_list').subscribe(resp=>{
      this.db.drType = resp['result'].data
      this.db.drType.map(r=>r.id = r.id.toString())      
    })
  }
  
  
  form: FormGroup;
  
  formsInit(data) {
    this.form = this.db.formBuilder.group({
      company_name: [  this.activatedroute.snapshot.params.id ? data.basicDetail.company_name : null , []],
      first_name: [  this.activatedroute.snapshot.params.id ? data.basicDetail.first_name : null , [Validators.required]],
      last_name: [  this.activatedroute.snapshot.params.id ? data.basicDetail.last_name : null , [Validators.required]],
      gender :[this.activatedroute.snapshot.params.id ? data.basicDetail.gender : null ,[]],
      type :[this.activatedroute.snapshot.params.id ? data.basicDetail.type : null ,[]],
      // cust_code: [  null , []],
      // gst_no: [  null , [Validators.pattern(/^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9]+$/),Validators.minLength(15)]],
      date_of_birth : [this.activatedroute.snapshot.params.id ? moment(data.basicDetail.date_of_birth).format('YYYY-MM-DD') : null   , []],
      date_of_anniversary  : [ this.activatedroute.snapshot.params.id ? moment(data.basicDetail.date_of_anniversary).format('YYYY-MM-DD') : null  ],
      cust_type_id: [  this.activatedroute.snapshot.params.id ? data.basicDetail.cust_type_id : null , [Validators.required]],
      cust_type: [  this.activatedroute.snapshot.params.id ? data.basicDetail.cust_type : null , []],
      status: [  this.activatedroute.snapshot.params.id ? data.basicDetail.status : null , [Validators.required]],
      // email : [this.activatedroute.snapshot.params.id ? data.basicDetail.email : null , [Validators.pattern(/^\w.+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/)]],
      mobile : [this.activatedroute.snapshot.params.id ? data.basicDetail.mobile : null   , [Validators.required,Validators.pattern(/^((\\+91-?)|0)?[0-9]{10}$/)]],
      landline_no: [  this.activatedroute.snapshot.params.id ? data.basicDetail.landline_no : null , []],
      // username: [  null , [Validators.required]],
      // password: [  null , [Validators.required]],
      // credit_day: [  null , [Validators.required]],
      // dealer_status : [this.activatedroute.snapshot.params.id ? data.dealerDetail.status : null , []],
      dealer_counter_name : [this.activatedroute.snapshot.params.id ? data.basicDetail.dealer_counter_name : null , []],
      // counter_code : [this.activatedroute.snapshot.params.id ? data.counter_code : null , []],
      dealer_contact_person_name : [this.activatedroute.snapshot.params.id ? data.basicDetail.dealer_contact_person_name : null , []],
      dealer_name : [this.activatedroute.snapshot.params.id ? data.basicDetail.dealer_name : null , []],
      dealer_mobile : [this.activatedroute.snapshot.params.id ? data.basicDetail.dealer_mobile : null , []],
      dealer_city : [this.activatedroute.snapshot.params.id ? data.basicDetail.dealer_city : null , []],
      dealer_contact_person_address : [this.activatedroute.snapshot.params.id ? data.basicDetail.dealer_contact_person_address : null , []],
      upi_id : [this.activatedroute.snapshot.params.id ? data.basicDetail.upi_id: null,[]],
      sales_person_name : [this.activatedroute.snapshot.params.id ? data.basicDetail.sales_person_name : null,[]],
      sales_person_code : [this.activatedroute.snapshot.params.id ? data.basicDetail.sales_person_code : null,[]],
      sales_person_mobile : [this.activatedroute.snapshot.params.id ? data.basicDetail.sales_person_mobile : null,[]],
      whatsapp_no :[this.activatedroute.snapshot.params.id ? data.basicDetail.whatsapp_no : null,[]] ,
      ifsc_code:[this.activatedroute.snapshot.params.id ? data.basicDetail.ifsc_code : null,[]],
      account_holder_name:[this.activatedroute.snapshot.params.id ? data.basicDetail.account_holder_name : null,[]],
      account_number:[this.activatedroute.snapshot.params.id ? data.basicDetail.account_number : null,[]],
      bank_name:[this.activatedroute.snapshot.params.id ? data.basicDetail.bank_name : null,[]],
      doc_type  : [ 'Adhar Card',],      //Validators.required
      doc_no : [ null,],       //Validators.required
      doc_image : [ null,],//Validators.required
      doc_image_1 : [ null,],//Validators.required
      image : [ null],
      image_1 : [ null],
      street: [  this.activatedroute.snapshot.params.id ? data.basicDetail.street : null , []],
      state_name: [  this.activatedroute.snapshot.params.id ? data.basicDetail.state_name : null , []],
      district_name: [  this.activatedroute.snapshot.params.id ? data.basicDetail.district_name : null , []],
      city: [  this.activatedroute.snapshot.params.id ? data.basicDetail.city : null , []],
      zone: [  this.activatedroute.snapshot.params.id ? data.basicDetail.zone : null , []],
      area: [  this.activatedroute.snapshot.params.id ? data.basicDetail.area : null , []],
      pincode: [  this.activatedroute.snapshot.params.id ? data.basicDetail.pincode : null , []],
      cust_id: [  this.activatedroute.snapshot.params.id ? this.activatedroute.snapshot.params.id : null],
      cp_email: [this.activatedroute.snapshot.params.id ? data.contactDetail.cp_email : null, []],
      cp_designation: [ null, []],
      cp_mobile: [null, []],
      cp_name: [ null , []],
      contactDetail: [ [] , []],
      dealer:[this.activatedroute.snapshot.params.id && data.dealerDetail.length ? data.dealerDetail[0].dealer_id : null ],
      // brandDetail: [[] , [Validators.required]],
      assignedUser: [[] , []],
    })
    
    this.getUsers(data);
    
    this.db.getDistricts(this.form.value.state_name);
    this.db.getCity(this.form.value.state_name,this.form.value.district_name);
    // this.db.getArea(this.form.value.state_name,this.form.value.district_name,this.form.value.city);
    // this.db.getBeat(this.form.value.state_name,this.form.value.district_name,this.form.value.city,this.form.value.area);
    
    if(!this.activatedroute.snapshot.params.id){ this.form.controls['cust_type_id'].setValue(this.type)} 
    
    if(this.activatedroute.snapshot.params.id){
      console.log('type ---->', data.basicDetail.cust_type_id);
      this.type = data.basicDetail.cust_type_id;
      this.typeName = this.type == 3 ? 'Carpenter' : 'Distributor';

      this.getDealers();
    }
    
    
    data.documentDetail.map(r => {
      // if(r.doc_type.toLowerCase().includes('company')){
      //   this.form.controls['company_doc'].setValue(r.doc_filename.replace(this.db.s3path,''));
      // }else 
      if (r.doc_type.toLowerCase().includes('pan')) {
        this.form.controls['pan_no'].setValue(r.doc_type_value);
        this.form.controls['pan_image'].setValue(r.doc_filename.replace(this.db.s3path, ''));
        this.form.controls['image_4'].setValue(r.doc_filename.replace(this.db.s3path, ''));
      } else {
        this.form.controls['doc_no'].setValue(r.doc_type_value);
        this.form.controls['doc_type'].setValue(r.doc_type);
        this.form.controls['doc_image'].setValue(r.doc_filename.replace(this.db.s3path, ''));
        this.form.controls['image'].setValue(r.doc_filename.replace(this.db.s3path, ''));
        this.form.controls['doc_image_1'].setValue(r.doc_filename_1.replace(this.db.s3path, ''));
        this.form.controls['image_1'].setValue(r.doc_filename_1.replace(this.db.s3path, ''));
      }
    })
    
  }
  onSubmit(){
    console.log(this.form);
    if(this.form.invalid){
      this.form.markAllAsTouched();
      const invalid = [];
      const controls = this.form.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(name);
        }
      }
      console.log('invalid',invalid);
      return invalid;
    }
    
    let reqData:any = {};
    this.form.value.date_of_birth = this.form.value.date_of_birth == 'Invalid date' ? '0000-00-00' : this.form.value.date_of_birth;
    this.form.value.date_of_anniversary = this.form.value.date_of_anniversary == 'Invalid date' ? '0000-00-00' : this.form.value.date_of_anniversary;
    reqData.basicDetail = this.form.value
    // reqData.basicDetail.cust_type = this.db.drType.filter(r=>r.id === reqData.basicDetail.cust_type_id)[0].name
    // reqData.contactDetail = this.form.value.contactDetail;
    
    if(reqData.basicDetail.dealer){
      reqData.basicDetail.dealer_cp_name = this.dealers.filter(r=>r.id == reqData.basicDetail.dealer)[0].first_name;
      reqData.basicDetail.dealer_name = this.dealers.filter(r=>r.id == reqData.basicDetail.dealer)[0].company_name;
      reqData.basicDetail.dealer_mobile = this.dealers.filter(r=>r.id == reqData.basicDetail.dealer)[0].mobile;
      reqData.basicDetail.dealer_address = this.dealers.filter(r=>r.id == reqData.basicDetail.dealer)[0].street;
    }
    
    reqData.assignedUser = [
      {
        emp_code:this.form.value.assignedUser.emp_code,
        id:this.form.value.assignedUser.id,
        name:this.form.value.assignedUser.name,
        role:this.form.value.assignedUser.role,
        role_name:this.form.value.assignedUser.role_name
      }
    ];
    
    reqData.basicDetail.assignedUser = reqData.assignedUser;
    
    // reqData.brandDetail = this.form.value.brandDetail;
    console.log(reqData);
    // return
    
    // if(this.form.value.contactDetail.length==0){
    //   this.db.presentAlert('Error','Please Enter atleast one contact detail')
    //   return;
    // }
    reqData.status = this.form.value.status
    this.db.presentLoader();
    this.db.postReq(reqData,this.activatedroute.snapshot.params.id  ? 'dis_network/update_network' : 'dis_network/add_network').subscribe(resp=>{
      this.db.dismissLoader();
      if(resp['status'] == 'success'){
        this.db.successAlert(resp['status'],resp['message']);
        // this.events.publish('tabActive',{})
        this.backClicked();
        this.db.router.navigateByUrl('dr-list/'+this.form.value.cust_type_id,{replaceUrl:true})
      }else{
        if(resp['message']=='Invalid token'){
          this.db.sessionExpire();
          return;
        }
        this.db.presentAlert(resp['status'],resp['message'])
      }
    },err=>{
      this.db.errDismissLoader();
    })
    
  }
  
  backClicked() {
    this._location.back();
  }
  addContactDetails(){
    console.log(this.form.value,this.form.value.cp_name ,this.form.value.cp_designation ,this.form.value.cp_email ,this.form.value.cp_mobile)
    if(!this.form.value.cp_name || !this.form.value.cp_designation || !this.form.value.cp_email || !this.form.value.cp_mobile){
      this.db.presentAlert('Error','Please fill all the required details to continue!');
      return;
    }
    var emailpattern = /^\w.+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/
    console.log(emailpattern.test(this.form.value.cp_email));
    
    if(!emailpattern.test(this.form.value.cp_email)){
      this.db.presentAlert('Error','Please enter a valid email!');
      return;
    }
    var mobilepattern = /^((\\+91-?)|0)?[0-9]{10}$/
    if(!mobilepattern.test(this.form.value.cp_mobile)){
      this.db.presentAlert('Error','Please enter a valid mobile!');
      return;
    }
    this.form.controls['contactDetail'].setValue([...this.form.value.contactDetail,{name:this.form.value.cp_name ,email:this.form.value.cp_email,designation:this.form.value.cp_designation,mobile:this.form.value.cp_mobile}])
    this.form.controls['cp_name'].setValue(null);
    this.form.controls['cp_designation'].setValue(null);
    this.form.controls['cp_mobile'].setValue(null);
    this.form.controls['cp_email'].setValue(null);
  }
  deleteContact(index){
    swal({
      title: "Are you sure?",
      text: "You want to delete this!",
      icon: "warning",
      buttons: ["Cancel", "Confirm"],
      dangerMode: true,
    })
    .then((willDelete) => {        
      if (willDelete) {  
        this.form.controls['contactDetail'].setValue(this.form.value.contactDetail.filter((r,i)=> i != index ))
      } else {
        swal("Your data is safe!");
      }
    });
    
  }
  brandsData:any=[]
  filteredbrandsData:any=[];
  getBrands(){
    let reqData = {
      limit : 30000,
      start : 0,
      filter : {}
    }
    this.db.presentLoader();
    this.db.postReq(reqData,'master/brand').subscribe(resp=>{
      if(resp['status'] == 'success'){
        resp['result'].data.map(r=>{
          this.brandsData.push({brand_name:r.name,brand_id:r.id})
          this.filteredbrandsData.push({brand_name:r.name,brand_id:r.id})
        });
      }else{
        if(resp['message']=='Invalid token'){
          this.db.sessionExpire();
          return;
        }
        this.db.presentAlert(resp['status'],resp['message'])
      }
    },err=>{
      
    })
  }
  
  dealers:any=[];
  getDealers(){
    let reqData = {
      limit : 100000,
      start : 0,
      filter :{
        // "branch":this.form.value.branch,
        "cust_type_id": "3",
        "is_lead": "0",
        "status": ""
      }
    }
    this.db.presentLoader();
    this.db.postReq(reqData,'dis_network/list').subscribe(resp=>{
      if(resp['status'] == 'success'){
        this.dealers = resp['result'].data;
        this.db.filteredResults.dealers = resp['result'].data;
        console.log('dealers -->',this.dealers);
        
      }else{
        if(resp['message']=='Invalid token'){
          this.db.sessionExpire();
          return;
        }
        this.db.presentAlert(resp['status'],resp['message'])
      }
    },err=>{
      this.db.errHandler(err);
      
    })
  }
  
  changeListener($event): void {
    
    console.log($event);
    
    var file = $event.target.files[0];
    var reader = new FileReader();
    var image
    reader.onloadend = function () {
      image = reader.result;
    }
    setTimeout(() => {
      console.log(image);
      let reqData = {base64:image}
      this.db.presentLoader();
      this.db.postReq(reqData,'base64_to_file').subscribe(resp=>{
        this.db.dismissLoader();
        if(resp['status'] == 'success'){
          this.form.controls['doc_image'].setValue(resp['response'].fileName);
        }else{
          if(resp['message']=='Invalid token'){
            this.db.sessionExpire();
            return;
          }
          this.db.presentAlert(resp['status'],resp['message'])
        }
      },err=>{
        this.db.errDismissLoader();
      })
    }, 100);
    
    reader.readAsDataURL(file);
    
  }
  
  
  
  changeListener_1($event): void {
    
    console.log($event);
    
    var file = $event.target.files[0];
    var reader = new FileReader();
    var image
    reader.onloadend = function () {
      image = reader.result;
    }
    setTimeout(() => {
      console.log(image);
      let reqData = {base64:image}
      this.db.presentLoader();
      this.db.postReq(reqData,'base64_to_file').subscribe(resp=>{
        this.db.dismissLoader();
        if(resp['status'] == 'success'){
          this.form.controls['doc_image_1'].setValue(resp['response'].fileName);
        }else{
          if(resp['message']=='Invalid token'){
            this.db.sessionExpire();
            return;
          }
          this.db.presentAlert(resp['status'],resp['message'])
        }
      },err=>{
        this.db.errDismissLoader();
      })
    }, 100);
    
    reader.readAsDataURL(file);
    
  }
  
  
  usersData:any=[]
  filteredUsersData:any=[]
  getUsers(data:any={}){
    let reqData = {
      limit : 30000,
      start : 0,
      filter : {}
    }
    this.db.presentLoader();
    this.db.postReq(reqData,'dis_network/sales_user').subscribe(resp=>{
      if(resp['status'] == 'success'){
        this.usersData = resp['result'].data;
        this.filteredUsersData = this.usersData
        
        // console.log(data.salesUserDetail.length);
        if(data.salesUserDetail){
          data.salesUserDetail.map(r=>{
            let i = this.usersData.findIndex(item => item.id == r.user_id)
            if(i!= -1){
              this.form.controls['assignedUser'].setValue([...this.form.value.assignedUser,this.usersData[i]]);
            }
          })
        }  
        
      }else{
        if(resp['message']=='Invalid token'){
          this.db.sessionExpire();
          return;
        }
        this.db.presentAlert(resp['status'],resp['message'])
      }
    },err=>{
      
    })
  }
  
  postalData:any=[];
  pincodeHandler(){
    let reqData = {
      filter:{pincode:this.form.value.pincode}
    }
    this.db.presentLoader();
    this.db.postReq(reqData,'master/getDetailByPincode').subscribe(resp=>{
      if(resp['status'] == 'success'){
        this.postalData = resp['result'].data;
      }else{
        if(resp['message']=='Invalid token'){
          this.db.sessionExpire();
          return;
        }
        this.db.presentAlert(resp['status'],resp['message'])
      }
    },err=>{
      
    })
  }
  selectPostal(data){
    this.form.controls['state_name'].setValue(data.state_name);
    this.form.controls['district_name'].setValue(data.district_name);
    this.form.controls['city'].setValue(data.city);
    this.form.controls['area'].setValue(data.area);
    this.form.controls['zone'].setValue(data.zone);
    this.form.controls['beat'].setValue(data.beat);
  }
}